import { type ReactNode } from 'react';
import { Plus } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { DistributeLoadButton } from './distribute-load-button';

type Props = {
  search: string;
  onSearch: (v: string) => void;
  onAdd: () => void;
};

function ActionButtons({ onAdd }: { onAdd: () => void }): ReactNode {
  return (
    <div className="ml-auto flex items-center gap-sm">
      <DistributeLoadButton role="approacher" />
      <DistributeLoadButton role="mago" />
      <button
        onClick={onAdd}
        className="flex items-center gap-1 text-xs text-text-tertiary transition-colors hover:text-brand-red"
      >
        <Plus size={14} /> Añadir
      </button>
    </div>
  );
}

export function ApproachersToolbar({
  search,
  onSearch,
  onAdd,
}: Props): ReactNode {
  return (
    <div className="flex items-center gap-sm">
      <Input
        placeholder="Buscar..."
        value={search}
        onChange={(e) => onSearch(e.target.value)}
        className="w-full sm:!w-36"
      />
      <ActionButtons onAdd={onAdd} />
    </div>
  );
}
